/**
 * @fileoverview Model representing Apple Country Info data.
 *
 * @author Michael Zhang (jinzhang@yext.com)
 */

import {AppleBusiness} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/applebusiness';

export class AppleCountryInfo {
  /**
   * @param {{
   *  country: string,
   *  appleCompanyId: string,
   *  appleBusinesses: Array<AppleBusiness>,
   *  selectedAppleBusiness?: AppleBusiness,
   *  excluded: boolean
   * }} params
   */
  constructor(params) {
    /** @type {string} */
    this.country = params.country;
    /** @type {string} */
    this.appleCompanyId = params.appleCompanyId;
    /** @type {Array<AppleBusiness>} */
    this.appleBusinesses = params.appleBusinesses;
    /** @type {AppleBusiness | undefined} */
    this.selectedAppleBusiness = params.selectedAppleBusiness;
    /** @type {boolean} */
    this.excluded = params.excluded;
  }

  /**
   * @param {!AppleCountryInfoJson} json
   * @return {!AppleCountryInfo}
   */
  static fromJSON(json) {
    return new AppleCountryInfo({
      country: json['country'],
      appleCompanyId: json['appleCompanyId'],
      appleBusinesses: json['appleBusinesses'],
      selectedAppleBusiness: json['selectedAppleBusiness'],
      excluded: json['excluded'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  country: string,
 *  appleCompanyId: string,
 *  appleBusinesses: Array<AppleBusiness>,
 *  selectedAppleBusiness?: AppleBusiness,
 *  excluded: boolean
 * }}
 */
export var AppleCountryInfoJson;
